module.exports = __webpack_public_path__ + "static/img/stay-up-to-date-3.1907aeb.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/stay-up-to-date-3.jpg
// module id = qTUu
// module chunks = 0